// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"E4-z","colorTextValue":"F4-z","swatches":"G4-z","collapseLink":"H4-z","isCollapsed":"I4-z","dropdown":"J4-z","disabled":"K4-z"};